import { BotIcon, type LucideProps } from "lucide-react"
import type { ComponentType } from "react"
import {
  AlephAlphaIcon,
  AmazonBedrockIcon,
  AmazonSagemakerIcon,
  AzureIcon,
  ClaudeCodeIcon,
  ClaudeIcon,
  CloudflareIcon,
  CloudflareWorkersIcon,
  CohereIcon,
  CopilotIcon,
  CrewaiIcon,
  CursorIcon,
  DeepseekIcon,
  DspyIcon,
  ElevenlabsIcon,
  FlueIcon,
  GeminiIcon,
  GitlabIcon,
  GrokIcon,
  GroqIcon,
  HaystackIcon,
  HermesIcon,
  HuggingfaceIcon,
  KilocodeIcon,
  KimiIcon,
  LangchainIcon,
  LitellmIcon,
  LlamaindexIcon,
  MetaIcon,
  MistralIcon,
  NvidiaIcon,
  OllamaIcon,
  OpenaiIcon,
  OpenClawIcon,
  OpencodeIcon,
  OpenrouterIcon,
  PerplexityIcon,
  PiIcon,
  PydanticAiIcon,
  QwenIcon,
  ReplicateIcon,
  ReplitIcon,
  TogetherIcon,
  V0Icon,
  VercelIcon,
  WatsonxIcon,
} from "./icons/index.tsx"

type ProviderIconComponent = ComponentType<LucideProps>

// Providers from https://models.dev/
// Icons from https://svgl.app/
export const PROVIDER_ICON_MAP: Record<string, ProviderIconComponent> = {
  /** Generic / framework integrations without a dedicated brand mark */
  generic: BotIcon,
  "aleph-alpha": AlephAlphaIcon,
  alibaba: QwenIcon,
  "alibaba-cn": QwenIcon,
  "amazon-bedrock": AmazonBedrockIcon,
  "amazon-sagemaker": AmazonSagemakerIcon,
  anthropic: ClaudeIcon, // Alternative: AnthropicIcon
  azure: AzureIcon, // Alternative: OpenaiIcon
  "azure-cognitive-services": AzureIcon,
  claude: ClaudeIcon,
  "claude-code": ClaudeCodeIcon,
  "cloudflare-ai-gateway": CloudflareIcon,
  "cloudflare-workers-ai": CloudflareWorkersIcon,
  codex: OpenaiIcon,
  cohere: CohereIcon,
  crewai: CrewaiIcon,
  cursor: CursorIcon,
  deepseek: DeepseekIcon,
  dspy: DspyIcon,
  elevenlabs: ElevenlabsIcon,
  eve: VercelIcon, // Eve is a Vercel framework
  flue: FlueIcon,
  "github-copilot": CopilotIcon,
  gitlab: GitlabIcon,
  google: GeminiIcon,
  "google-vertex": GeminiIcon,
  "google-vertex-anthropic": ClaudeIcon, // Alternative: AnthropicIcon
  groq: GroqIcon,
  haystack: HaystackIcon,
  hermes: HermesIcon,
  huggingface: HuggingfaceIcon,
  kilo: KilocodeIcon,
  "kimi-for-coding": KimiIcon,
  langchain: LangchainIcon,
  litellm: LitellmIcon,
  llama: OllamaIcon,
  llamaindex: LlamaindexIcon,
  MetaIcon,
  mistral: MistralIcon,
  moonshotai: KimiIcon,
  "moonshotai-cn": KimiIcon,
  nvidia: NvidiaIcon,
  "ollama-cloud": OllamaIcon,
  openai: OpenaiIcon,
  openclaw: OpenClawIcon,
  opencode: OpencodeIcon,
  "opencode-go": OpencodeIcon,
  openrouter: OpenrouterIcon,
  perplexity: PerplexityIcon,
  pi: PiIcon,
  "pydantic-ai": PydanticAiIcon,
  replicate: ReplicateIcon,
  replit: ReplitIcon,
  togetherai: TogetherIcon,
  v0: V0Icon,
  vercel: VercelIcon,
  watsonx: WatsonxIcon,
  xai: GrokIcon, // Alternative: XaiIcon
}
